export { default } from './IconButton';

export { default as iconButtonClasses } from './iconButtonClasses';
export * from './iconButtonClasses';
